export default __webpack_public_path__ + "static/media/folderMini.801d4a3e.svg";